module.exports = __webpack_public_path__ + "static/Asiahn-c6bd971a6edae01b3dc29943eb652eec.png";